// AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
const projectImages = {
  "100College": [
    "/prjimg/100College/0.webp",
    "/prjimg/100College/College100_1.webp",
    "/prjimg/100College/College100_2.webp",
    "/prjimg/100College/College100_3.webp",
    "/prjimg/100College/College100_4.webp"
  ],
  "101College": [
    "/prjimg/101College/0.webp",
    "/prjimg/101College/101College_2.webp",
    "/prjimg/101College/101College_3.webp",
    "/prjimg/101College/101College_4.webp",
    "/prjimg/101College/101College_5.webp",
    "/prjimg/101College/101College_6.webp",
    "/prjimg/101College/101College_7.webp"
  ],
  "105West1st": [
    "/prjimg/105West1st/0.webp",
    "/prjimg/105West1st/105w1street_cropped.webp",
    "/prjimg/105West1st/West_1.webp",
    "/prjimg/105West1st/West_2.webp",
    "/prjimg/105West1st/West_3.webp",
    "/prjimg/105West1st/West_4.webp",
    "/prjimg/105West1st/West_5.webp"
  ],
  "121Broadway": [
    "/prjimg/121Broadway/0.webp",
    "/prjimg/121Broadway/121broadway_long.webp",
    "/prjimg/121Broadway/broadway_1.webp",
    "/prjimg/121Broadway/broadway_2.webp"
  ],
  "1502ndSt": [
    "/prjimg/1502ndSt/Second150_1.webp",
    "/prjimg/1502ndSt/Second150_2.webp"
  ],
  "22Liberty": [
    "/prjimg/22Liberty/0.webp",
    "/prjimg/22Liberty/1.webp",
    "/prjimg/22Liberty/2.webp",
    "/prjimg/22Liberty/3.webp",
    "/prjimg/22Liberty/Liberty_1.webp",
    "/prjimg/22Liberty/Liberty_2.webp",
    "/prjimg/22Liberty/Liberty_3.webp",
    "/prjimg/22Liberty/Liberty_4.webp"
  ],
  "380Stuart": [
    "/prjimg/380Stuart/380Stuart_1.webp"
  ],
  "55Park": [
    "/prjimg/55Park/0.webp",
    "/prjimg/55Park/Park_1.webp",
    "/prjimg/55Park/Park_2.webp",
    "/prjimg/55Park/Park_3.webp",
    "/prjimg/55Park/Park_4.webp"
  ],
  "888Boylston": [
    "/prjimg/888Boylston/0.webp",
    "/prjimg/888Boylston/Boylston_1.webp",
    "/prjimg/888Boylston/Boylston_2.webp",
    "/prjimg/888Boylston/Boylston_3.webp",
    "/prjimg/888Boylston/Boylston_4.webp",
    "/prjimg/888Boylston/Boylston_5.webp"
  ],
  "88Seaport": [
    "/prjimg/88Seaport/0.webp",
    "/prjimg/88Seaport/2.webp",
    "/prjimg/88Seaport/88seaportalt.webp"
  ],
  "BUDentalSchool": [
    "/prjimg/BUDentalSchool/0.webp",
    "/prjimg/BUDentalSchool/Dental_2.webp",
    "/prjimg/BUDentalSchool/Dental_3.webp",
    "/prjimg/BUDentalSchool/Dental_4.webp",
    "/prjimg/BUDentalSchool/Dental_5.webp",
    "/prjimg/BUDentalSchool/Dental_6.webp"
  ],
  "BackBay": [
    "/prjimg/BackBay/0.webp",
    "/prjimg/BackBay/BackBay_1.webp",
    "/prjimg/BackBay/BackBay_2.webp",
    "/prjimg/BackBay/BackBay_3.webp",
    "/prjimg/BackBay/BackBay_4.webp"
  ],
  "Binney": [
    "/prjimg/Binney/0.webp",
    "/prjimg/Binney/Binney_1.webp"
  ],
  "BostonMed": [
    "/prjimg/BostonMed/0.webp",
    "/prjimg/BostonMed/BostonMed_1.webp",
    "/prjimg/BostonMed/BostonMed_2.webp",
    "/prjimg/BostonMed/BostonMed_3.webp",
    "/prjimg/BostonMed/BostonMed_4.webp"
  ],
  "BrighamWomens": [
    "/prjimg/BrighamWomens/0.webp",
    "/prjimg/BrighamWomens/Brigham_2.webp",
    "/prjimg/BrighamWomens/Brigham_3.webp",
    "/prjimg/BrighamWomens/Brigham_4.webp",
    "/prjimg/BrighamWomens/Brigham_5.webp"
  ],
  "BrownDanoffLab": [
    "/prjimg/BrownDanoffLab/0.webp"
  ],
  "BrownEngn": [
    "/prjimg/BrownEngn/0.webp",
    "/prjimg/BrownEngn/BrownEngn_1.webp",
    "/prjimg/BrownEngn/BrownEngn_2.webp",
    "/prjimg/BrownEngn/BrownEngn_3.webp",
    "/prjimg/BrownEngn/BrownEngn_4.webp",
    "/prjimg/BrownEngn/BrownEngn_5.webp",
    "/prjimg/BrownEngn/BrownEngn_6.webp"
  ],
  "BrownILSB": [
    "/prjimg/BrownILSB/BrownILSB.webp"
  ],
  "BrownITF": [
    "/prjimg/BrownITF/BrownITF_1.webp"
  ],
  "BryantBelloCenter": [
    "/prjimg/BryantBelloCenter/Bello_1.webp",
    "/prjimg/BryantBelloCenter/Bello_2.webp"
  ],
  "BulfinchCrossing": [
    "/prjimg/BulfinchCrossing/0.webp",
    "/prjimg/BulfinchCrossing/Bulfinch_1.webp",
    "/prjimg/BulfinchCrossing/Bulfinch_2.webp",
    "/prjimg/BulfinchCrossing/Bulfinch_3.webp",
    "/prjimg/BulfinchCrossing/Bulfinch_4.webp",
    "/prjimg/BulfinchCrossing/Bulfinch_5.webp",
    "/prjimg/BulfinchCrossing/Bulfinch_6.webp",
    "/prjimg/BulfinchCrossing/Bulfinch_7.webp"
  ],
  "DanburyHospital": [
    "/prjimg/DanburyHospital/0.webp",
    "/prjimg/DanburyHospital/Danbury_1.webp",
    "/prjimg/DanburyHospital/Danbury_2.webp"
  ],
  "DunkinDonutsCenter": [
    "/prjimg/DunkinDonutsCenter/0.webp",
    "/prjimg/DunkinDonutsCenter/Dunk_1.webp",
    "/prjimg/DunkinDonutsCenter/Dunk_3.webp"
  ],
  "Eataly": [
    "/prjimg/Eataly/0.webp",
    "/prjimg/Eataly/Eataly_1.webp"
  ],
  "FenwayCenterP2": [
    "/prjimg/FenwayCenterP2/Fenway_1.webp",
    "/prjimg/FenwayCenterP2/Fenway_2.webp",
    "/prjimg/FenwayCenterP2/Fenway_3.webp",
    "/prjimg/FenwayCenterP2/Fenway_4.webp",
    "/prjimg/FenwayCenterP2/Fenway_5.webp",
    "/prjimg/FenwayCenterP2/Fenway_6.webp",
    "/prjimg/FenwayCenterP2/Fenway_7.webp",
    "/prjimg/FenwayCenterP2/Fenway_8.webp",
    "/prjimg/FenwayCenterP2/fenwayphaseii.webp"
  ],
  "Foxwoods": [
    "/prjimg/Foxwoods/0.webp",
    "/prjimg/Foxwoods/Foxwoods_1.webp",
    "/prjimg/Foxwoods/Foxwoods_2.webp",
    "/prjimg/Foxwoods/Foxwoods_3.webp"
  ],
  "GoogleHQ": [
    "/prjimg/GoogleHQ/0.webp",
    "/prjimg/GoogleHQ/Google_1.webp",
    "/prjimg/GoogleHQ/Google_2.webp",
    "/prjimg/GoogleHQ/Google_3.webp",
    "/prjimg/GoogleHQ/Google_4.webp",
    "/prjimg/GoogleHQ/Google_5.webp",
    "/prjimg/GoogleHQ/Google_6.webp"
  ],
  "GreatWolf": [
    "/prjimg/GreatWolf/0.webp"
  ],
  "HarvardERC": [
    "/prjimg/HarvardERC/0.webp",
    "/prjimg/HarvardERC/HarvardERC_2.webp",
    "/prjimg/HarvardERC/HarvardERC_3.webp",
    "/prjimg/HarvardERC/HarvardERC_4.webp",
    "/prjimg/HarvardERC/HarvardERC_5.webp",
    "/prjimg/HarvardERC/HarvardERC_6.webp",
    "/prjimg/HarvardERC/HarvardERC_7.webp"
  ],
  "Knights": [
    "/prjimg/Knights/0.webp",
    "/prjimg/Knights/Knights_1.webp",
    "/prjimg/Knights/Knights_2.webp",
    "/prjimg/Knights/Knights_3.webp"
  ],
  "MGM": [
    "/prjimg/MGM/0.webp",
    "/prjimg/MGM/MGM_1.webp",
    "/prjimg/MGM/MGM_2.webp",
    "/prjimg/MGM/MGM_3.webp"
  ],
  "MITSite5": [
    "/prjimg/MITSite5/0.webp",
    "/prjimg/MITSite5/MIT_1.webp",
    "/prjimg/MITSite5/MIT_2.webp",
    "/prjimg/MITSite5/MIT_3.webp",
    "/prjimg/MITSite5/MIT_4.webp"
  ],
  "MassGeneral": [
    "/prjimg/MassGeneral/0.webp",
    "/prjimg/MassGeneral/MassGeneral_1.webp",
    "/prjimg/MassGeneral/MassGeneral_2.webp",
    "/prjimg/MassGeneral/MassGeneral_3.webp",
    "/prjimg/MassGeneral/MassGeneral_4.webp"
  ],
  "MassGeneralP2": [
    "/prjimg/MassGeneralP2/0.webp"
  ],
  "MassMutualFanPier": [
    "/prjimg/MassMutualFanPier/0.webp",
    "/prjimg/MassMutualFanPier/MassMutual_1.webp",
    "/prjimg/MassMutualFanPier/MassMutual_2.webp",
    "/prjimg/MassMutualFanPier/MassMutual_3.webp",
    "/prjimg/MassMutualFanPier/MassMutual_4.webp",
    "/prjimg/MassMutualFanPier/MassMutual_5.webp",
    "/prjimg/MassMutualFanPier/MassMutual_6.webp",
    "/prjimg/MassMutualFanPier/MassMutual_7.webp",
    "/prjimg/MassMutualFanPier/massmutual_home.webp"
  ],
  "MoheganSunEarth": [
    "/prjimg/MoheganSunEarth/Earth.webp",
    "/prjimg/MoheganSunEarth/Earth_2.webp",
    "/prjimg/MoheganSunEarth/Earth_3.webp",
    "/prjimg/MoheganSunEarth/Earth_4.webp"
  ],
  "MoheganSunTower": [
    "/prjimg/MoheganSunTower/0.webp",
    "/prjimg/MoheganSunTower/Tower_1.webp",
    "/prjimg/MoheganSunTower/Tower_2.webp",
    "/prjimg/MoheganSunTower/Tower_3.webp",
    "/prjimg/MoheganSunTower/Tower_4.webp"
  ],
  "NorwalkHospital": [
    "/prjimg/NorwalkHospital/0.webp",
    "/prjimg/NorwalkHospital/Norwalk_1.webp",
    "/prjimg/NorwalkHospital/Norwalk_2.webp",
    "/prjimg/NorwalkHospital/Norwalk_3.webp",
    "/prjimg/NorwalkHospital/Norwalk_4.webp"
  ],
  "PCBusinessSchool": [
    "/prjimg/PCBusinessSchool/PCBusiness_1.webp",
    "/prjimg/PCBusinessSchool/PCBusiness_2.webp",
    "/prjimg/PCBusinessSchool/PCBusiness_3.webp"
  ],
  "PCFriarCenter": [
    "/prjimg/PCFriarCenter/0.webp",
    "/prjimg/PCFriarCenter/Friar_1.webp",
    "/prjimg/PCFriarCenter/Friar_2.webp",
    "/prjimg/PCFriarCenter/Friar_3.webp",
    "/prjimg/PCFriarCenter/Friar_4.webp",
    "/prjimg/PCFriarCenter/Friar_5.webp",
    "/prjimg/PCFriarCenter/Friar_6.webp"
  ],
  "PCNursingSchool": [
    "/prjimg/PCNursingSchool/0.webp"
  ],
  "ParcelG": [
    "/prjimg/ParcelG/ParcelG_1.webp"
  ],
  "Pier4": [
    "/prjimg/Pier4/0.webp",
    "/prjimg/Pier4/Pier_1.webp",
    "/prjimg/Pier4/Pier_2.webp",
    "/prjimg/Pier4/Pier_3.webp",
    "/prjimg/Pier4/Pier_4.webp",
    "/prjimg/Pier4/pier4_cropped.webp"
  ],
  "ProvidencePlace": [
    "/prjimg/ProvidencePlace/ProvPlace_1.webp",
    "/prjimg/ProvidencePlace/ProvPlace_2.webp",
    "/prjimg/ProvidencePlace/pvdplace.webp"
  ],
  "PrudentialCenter": [
    "/prjimg/PrudentialCenter/0.webp",
    "/prjimg/PrudentialCenter/Prudential_1.webp"
  ],
  "QuinnipiacAcademic": [
    "/prjimg/QuinnipiacAcademic/0.webp"
  ],
  "QuinnipiacBusiness": [
    "/prjimg/QuinnipiacBusiness/0.webp"
  ],
  "QuinnipiacWellness": [
    "/prjimg/QuinnipiacWellness/Wellness_1.webp",
    "/prjimg/QuinnipiacWellness/Wellness_2.webp",
    "/prjimg/QuinnipiacWellness/Wellness_3.webp",
    "/prjimg/QuinnipiacWellness/Wellness_4.webp"
  ],
  "RagonInstituteII": [
    "/prjimg/RagonInstituteII/Ragon_1.webp",
    "/prjimg/RagonInstituteII/Ragon_2.webp",
    "/prjimg/RagonInstituteII/Ragon_3.webp",
    "/prjimg/RagonInstituteII/Ragon_4.webp",
    "/prjimg/RagonInstituteII/Ragon_5.webp",
    "/prjimg/RagonInstituteII/Ragon_6.webp",
    "/prjimg/RagonInstituteII/Ragon_7.webp",
    "/prjimg/RagonInstituteII/ragon_edit.webp"
  ],
  "SHUHockey": [
    "/prjimg/SHUHockey/0.webp"
  ],
  "SHUMerton": [
    "/prjimg/SHUMerton/0.webp"
  ],
  "SHUSeton": [
    "/prjimg/SHUSeton/0.webp"
  ],
  "SouthStreetLanding": [
    "/prjimg/SouthStreetLanding/0.webp",
    "/prjimg/SouthStreetLanding/SSL_1.webp",
    "/prjimg/SouthStreetLanding/SSL_2.webp",
    "/prjimg/SouthStreetLanding/SSL_3.webp",
    "/prjimg/SouthStreetLanding/SSL_4.webp"
  ],
  "StamfordHospital": [
    "/prjimg/StamfordHospital/0.webp",
    "/prjimg/StamfordHospital/Stamford_1.webp",
    "/prjimg/StamfordHospital/Stamford_2.webp",
    "/prjimg/StamfordHospital/Stamford_3.webp",
    "/prjimg/StamfordHospital/Stamford_4.webp"
  ],
  "UCONNGant": [
    "/prjimg/UCONNGant/Gant_1.webp",
    "/prjimg/UCONNGant/Gant_2.webp",
    "/prjimg/UCONNGant/Gant_3.webp",
    "/prjimg/UCONNGant/Gant_4.webp",
    "/prjimg/UCONNGant/Gant_5.webp",
    "/prjimg/UCONNGant/Gant_6.webp"
  ],
  "UCONNStem": [
    "/prjimg/UCONNStem/0.webp",
    "/prjimg/UCONNStem/UCONNStem_1.webp",
    "/prjimg/UCONNStem/UCONNStem_2.webp"
  ],
  "UMassInpatient": [
    "/prjimg/UMassInpatient/umassinpatient.webp"
  ],
  "UMassNERB": [
    "/prjimg/UMassNERB/UMassNERB.webp"
  ],
  "URIEngn": [
    "/prjimg/URIEngn/0.webp",
    "/prjimg/URIEngn/URIEngn_1.webp",
    "/prjimg/URIEngn/URIEngn_2.webp",
    "/prjimg/URIEngn/URIEngn_3.webp",
    "/prjimg/URIEngn/URIEngn_4.webp",
    "/prjimg/URIEngn/URIEngn_5.webp"
  ],
  "VolpeC3": [
    "/prjimg/VolpeC3/Volpe_1.webp",
    "/prjimg/VolpeC3/volpe.webp"
  ],
  "WhitePlains": [
    "/prjimg/WhitePlains/0.webp",
    "/prjimg/WhitePlains/WhitePlains_1.webp",
    "/prjimg/WhitePlains/WhitePlains_2.webp",
    "/prjimg/WhitePlains/WhitePlains_3.webp",
    "/prjimg/WhitePlains/WhitePlains_4.webp",
    "/prjimg/WhitePlains/WhitePlains_5.webp"
  ],
  "WomenInfants": [
    "/prjimg/WomenInfants/0.webp"
  ],
  "YaleGradHousing": [
    "/prjimg/YaleGradHousing/0.webp"
  ],
  "YaleKline": [
    "/prjimg/YaleKline/0.webp"
  ],
  "YaleNewHaven": [
    "/prjimg/YaleNewHaven/YaleNewHaven_2.webp",
    "/prjimg/YaleNewHaven/yalenewhaven.webp"
  ],
  "YaleNewHavenNeuro": [
    "/prjimg/YaleNewHavenNeuro/0.webp"
  ],
  "YalePeabody": [
    "/prjimg/YalePeabody/0.webp",
    "/prjimg/YalePeabody/Peabody_1.webp",
    "/prjimg/YalePeabody/Peabody_2.webp",
    "/prjimg/YalePeabody/Peabody_3.webp",
    "/prjimg/YalePeabody/Peabody_4.webp",
    "/prjimg/YalePeabody/Peabody_5.webp"
  ],
  "YaleSmilow": [
    "/prjimg/YaleSmilow/0.webp",
    "/prjimg/YaleSmilow/Smilow_1.webp",
    "/prjimg/YaleSmilow/Smilow_2.webp",
    "/prjimg/YaleSmilow/Smilow_3.webp",
    "/prjimg/YaleSmilow/Smilow_4.webp",
    "/prjimg/YaleSmilow/Smilow_5.webp",
    "/prjimg/YaleSmilow/Smilow_6.webp"
  ],
  "YaleWrightLab": [
    "/prjimg/YaleWrightLab/WrightLab_1.webp"
  ]
};
export default projectImages;